const SELECTOR = "[data-lightbox]";

function captionOf(trigger) {
  if (trigger.dataset.lightbox) {
    return trigger.dataset.lightbox;
  }

  const figure = trigger.closest("figure");
  const caption = figure ? figure.querySelector("figcaption") : null;

  return caption ? caption.textContent.trim() : "";
}

function groupOf(trigger) {
  const scope =
    trigger.closest(".wp-block-gallery") || trigger.closest(".wp-content");

  if (!scope) {
    return [trigger];
  }

  const group = Array.from(scope.querySelectorAll(SELECTOR));

  return group.length ? group : [trigger];
}

export function initLightbox() {
  const triggers = document.querySelectorAll(SELECTOR);

  if (!triggers.length || typeof HTMLDialogElement === "undefined") {
    return;
  }

  const dialog = document.createElement("dialog");
  dialog.className = "lightbox";
  dialog.setAttribute("aria-label", "Podgląd zdjęcia");
  dialog.innerHTML = `
    <button type="button" class="lightbox__close">
      <span class="visually-hidden">Zamknij podgląd</span>
      <span aria-hidden="true">&times;</span>
    </button>
    <button type="button" class="lightbox__nav lightbox__nav--prev">
      <span class="visually-hidden">Poprzednie zdjęcie</span>
      <span aria-hidden="true"></span>
    </button>
    <figure class="lightbox__figure">
      <img class="lightbox__img" alt="">
      <figcaption class="lightbox__caption"></figcaption>
    </figure>
    <button type="button" class="lightbox__nav lightbox__nav--next">
      <span class="visually-hidden">Następne zdjęcie</span>
      <span aria-hidden="true"></span>
    </button>
    <p class="lightbox__counter" role="status"></p>
  `;

  document.body.appendChild(dialog);

  const image = dialog.querySelector(".lightbox__img");
  const caption = dialog.querySelector(".lightbox__caption");
  const counter = dialog.querySelector(".lightbox__counter");
  const closeButton = dialog.querySelector(".lightbox__close");
  const prevButton = dialog.querySelector(".lightbox__nav--prev");
  const nextButton = dialog.querySelector(".lightbox__nav--next");

  let group = [];
  let index = 0;

  const preload = (position) => {
    const trigger = group[position];

    if (!trigger) {
      return;
    }

    const preloaded = new Image();
    preloaded.src = trigger.href;
  };

  const show = (position) => {
    index = (position + group.length) % group.length;

    const trigger = group[index];
    const source = trigger.querySelector("img");
    const text = captionOf(trigger);

    image.src = trigger.href;
    image.alt = source ? source.alt : text;

    caption.textContent = text;
    caption.hidden = !text;

    counter.textContent = `${index + 1} z ${group.length}`;
    counter.hidden = group.length < 2;

    prevButton.hidden = group.length < 2;
    nextButton.hidden = group.length < 2;

    preload(index + 1 >= group.length ? 0 : index + 1);
    preload(index - 1 < 0 ? group.length - 1 : index - 1);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey) {
        return;
      }

      event.preventDefault();

      group = groupOf(trigger);
      show(group.indexOf(trigger));
      dialog.showModal();
    });
  });

  prevButton.addEventListener("click", () => show(index - 1));
  nextButton.addEventListener("click", () => show(index + 1));
  closeButton.addEventListener("click", () => dialog.close());

  dialog.addEventListener("keydown", (event) => {
    if (group.length < 2) {
      return;
    }

    if (event.key === "ArrowLeft") {
      event.preventDefault();
      show(index - 1);
    }

    if (event.key === "ArrowRight") {
      event.preventDefault();
      show(index + 1);
    }
  });

  dialog.addEventListener("click", (event) => {
    if (
      event.target === dialog ||
      event.target.classList.contains("lightbox__figure")
    ) {
      dialog.close();
    }
  });

  dialog.addEventListener("close", () => {
    image.removeAttribute("src");
  });
}
